
/**
 * Utility functions for handling Supabase type casting issues
 */

/**
 * Helper function to safely type-cast Supabase query results
 * This avoids TypeScript errors when working with query results
 * that might include SelectQueryError types
 */
export function typecastSupabaseResult<T>(result: any): T {
  if (result && 'error' in result) {
    console.error('Error in Supabase result:', result);
    return {} as T; // Return empty object of type T when error
  }
  return result as T;
}

/**
 * Type guard to check if a value has a specific property
 * Useful for working with Supabase query results that might be error objects
 */
export function hasProperty<K extends string>(obj: unknown, prop: K): obj is Record<K, unknown> {
  return typeof obj === 'object' && obj !== null && prop in obj;
}

/**
 * Safely access a property from a potentially unknown object
 * Returns undefined if the property doesn't exist or the object is null
 */
export function safeGetProperty<T>(obj: unknown, prop: string): T | undefined {
  if (typeof obj === 'object' && obj !== null && prop in obj) {
    return (obj as Record<string, T>)[prop];
  }
  return undefined;
}
